// import DataFlow2 from "../../Assets/Icons/DataFlow2";
// import UsersPlus from "../../Assets/Icons/UsersPlus";
// import TooltipBox from "../../Components/TooltipBox";
// import InfoCircle from "../../Assets/Icons/InfoCircle";
// import ToggleButton from "../../Components/ToggleButton";

import { createColumnHelper } from "@tanstack/react-table";
import ToggleButton from "../../Components/ToggleButton";
import { utcToTime } from "../../utils/moment";
import Edit from "../../assets/icons/Edit";
// import { changeOrgActivationAPI } from "../../Store/Reducers/Organizations/Actions";

const columnHelper = createColumnHelper();

export const columns = (dispatch, toggleEditContract) => [
  {
    header: "",
    id: "index",
    disableSortBy: true,
    indexed: true,
    style: "text-center !w-[60px] text-gray",
  },
  columnHelper.accessor("username", {
    header: "Username",
    // meta: {
    //   filterVariant: "text",
    // },
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor("api_call", {
    header: "Api Call",
    // meta: { filterVariant: "text" },
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor("ip", {
    header: "ip",
    // meta: { filterVariant: "text" },
    cell: (info) => info.getValue().map((item) => item + ", "),
  }),
  columnHelper.accessor("quota", {
    header: "quota",
    // meta: { filterVariant: "text" },
    cell: (info) => info.getValue(),
  }),
  // columnHelper.accessor("is_active", {
  //   style: "text-center w-[180px]",
  //   header: "Activation",
  //   // meta: {
  //   //   filterVariant: "switch",
  //   //   switchOptions: { All: undefined, Active: true, Deactive: false },
  //   // },

  //   cell: (info) => {
  //     return (
  //       <div className="flex items-center justify-center w-full">
  //         <ToggleButton
  //           checked={info.getValue()}
  //           onChange={() => {
  //             // if (changeOrgActivation.loading) {
  //             //   return;
  //             // }
  //             // dispatch(
  //             //   changeOrgActivationAPI({
  //             //     organizationId: info.row.original.id,
  //             //   })
  //             // );
  //           }}
  //         />
  //       </div>
  //     );
  //   },
  // }),
  columnHelper.accessor("expire_datetime", {
    header: "expire_datetime",
    // meta: { filterVariant: "text" },
    cell: (info) => utcToTime(info.getValue(), "jYYYY/jM/jD"),
  }),
  {
    header: "Options",
    style: "text-center w-[100px]",
    cell: (info) => (
      <div
        className="cursor-pointer text-center flex w-full justify-center"
        onClick={() => toggleEditContract(info.row.original)}
      >
        <Edit />
      </div>
      // <div className="flex gap-4 w-full justify-center">
      //   <div
      //     onClick={() => console.log("info", info.row.original)}
      //     className="cursor-pointer"
      //   >
      //     <TooltipBox content="Add User" id="testId">
      //       <UsersPlus />
      //     </TooltipBox>
      //   </div>
      //   <div
      //     onClick={() => console.log("info", info.row.original)}
      //     className="cursor-pointer"
      //   >
      //     <TooltipBox content="Tenants" id="testId">
      //       <DataFlow2 />
      //     </TooltipBox>
      //   </div>
      //   <div
      //     onClick={() =>
      //       navigate(
      //         `/Organizations/${info.row.original.id}/${info.row.original.name}`
      //       )
      //     }
      //     className="cursor-pointer"
      //   >
      //     <TooltipBox content="Org. Info" id="testId">
      //       <InfoCircle />
      //     </TooltipBox>
      //   </div>
      // </div>
    ),
  },
];
